import { useGET } from '../shared/hooks';

const url = `/leagues?limit=1000`;

export function useLeagues() {
  const data = useGET(url);
  return data && data.results;
}
